export const defaultSection = [
    {
        title: '基础信息',
        fieldsMatch: [
            {
                reg: /^syncUpdate$/,
                options: { hidden: true }
            },
            {
                reg: /^categoryData$/
            },
            {
                reg: /^title$/
            },
            {
                reg: /^shopping_title$/
            },
            {
                reg: /^catProp$/
            },
            {
                reg: /^qualification$/
            },
            {
                reg: /^stuffStatus$/
            },
            {
                reg: /^globalStockNav$/,
                options: {
                    required: true,
                    rules: [
                        {
                            required: true,
                            message: '必填'
                        }
                    ]
                }
            },
            {
                reg: /^country$/,
                props: {
                    style: {
                        width: '180px'
                    }
                },
                options: {
                    className: 'styles.procurement'
                }
            },
            {
                reg: /^stockType$/,
                options: {
                    className: 'styles.procurement'
                }
            },
            {
                reg: /^globalStock$/
            },
            {
                reg: /^departurePlace$/,
                options: {
                    required: true,
                    rules: [
                        {
                            required: true,
                            message: '必填'
                        }
                    ]
                }
            },
            {
                reg: /^legalCustoms$/,
            },
            // {
            //     reg: /^customize$/
            // },
            {
                reg: /^shopcat$/
            }
        ]
    },
    {
        title: '食品安全',
        fieldsMatch: [
            {
                reg: /^barcode$/,
                props: {
                    style: {
                        width: '80%'
                    }
                }
            },
            { reg: /^taobaoFoodPrdLicense$/ },
            { reg: /^taobaoFoodDesignCode$/ },
            { reg: /^taobaoFoodAdditive$/ },
            { reg: /^taobaoFoodFactoryName$/ },
            { reg: /^taobaoFoodFactorySite$/ },
            { reg: /^taobaoFoodFactoryContact$/ },
            { reg: /^taobaoFoodMix$/ },
            { reg: /^taobaoFoodPeriod$/ },
            { reg: /^taobaoFoodPlanStorage$/ },
            { reg: /^taobaoFoodSupplier$/ },
            { reg: /^taobaoFoodProduceDate$/ },
            { reg: /^taobaoFoodStockDate$/ },
            { reg: /^taobaoFoodImages$/ },  // 食品安全图片
            { reg: /^food_images$/ },  // 食品安全图片
            { reg: /^food_security.food_nutrition_table$/ },// 营养成分表 food_security.food_nutrition_table
            { reg: /^food_security.organic_food$/ },// 是否为有机食品 food_security.organic_food
            { reg: /^food_security.organic_certification$/ }, // 有机证书编号 food_security.organic_certification
            { reg: /^food_security.is_green_food$/ }, // 是否为绿色食品 food_security.is_green_food
            { reg: /^food_security.green_food_level$/ }, // 绿色食品等级 food_security.green_food_level
            { reg: /^food_security.green_food_produce_number$/ }, // 绿色产品编号 food_security.green_food_produce_number
        ]
    },
    {
        title: '销售信息',
        fieldsMatch: [
            {
                reg: /^deliveryTimeType$/,
            },
            {
                reg: /^tbDeliveryTime$/,
                options: {
                    required: true,
                    rules: [
                        {
                            required: true,
                            message: '必填'
                        }
                    ]
                }
            },
            {
                reg: /^deliveryTimeSetBySku$/
            },
            {
                reg: /^saleProp$/
            },
            {
                reg: /^goodsSku$/
            },
            {
                reg: /^goodsSkuDetail$/
            },
            {
                reg: /^price$/,
                props: {
                    style: {
                        width: '180px'
                    }
                }
            },
            {
                reg: /^quantity$/,
                props: {
                    style: {
                        width: '180px'
                    }
                }
            },
            {
                reg: /^deliverWeight$/,
                props: {
                    style: {
                        width: '180px'
                    }
                }
            },
            {
                reg: /^outerId$/,
                props: {
                    style: {
                        width: '80%'
                    }
                }
            }
        ]
    },
    {
        title: '支付信息',
        fieldsMatch: [
            {
                reg: /^subStock$/
            },
            {
                reg: /^warranty$/
            },
            {
                reg: /^sevenDaySupport$/
            }, 
            {
                reg: /^sevenDayOptional$/
            },
            {
                reg: /^invoice$/
            },
            {
                reg: /^sellPromise$/
            },
            {
                reg: /^qualityIdentify$/
            }
        ]
    },
    // {
    //     title: '物流信息',
    //     fieldsMatch: [
    //         {
    //             reg: /^shopShelvesFreights$/
    //         },
    //         // {
    //         //     reg: /^tbExtractWay$/
    //         // },
    //         {
    //             reg: /^deliverVolumn$/
    //         },
    //         {
    //             reg: /^deliverWeight$/
    //         }
    //     ]
    // },
    {
        title: '图文描述',
        fieldsMatch: [
            {   // 引用套图
                reg: /^useGroupImages$/,
            },
            {
                reg: /^multiplePic$/
            },
            {
                reg: /^images$/
            },
            // {
            //     reg: /^imageVideoType$/
            // },
            // {
            //     reg: /^imageVideo$/
            // },
            {
                reg: /^threeToFourImages$/
            },
            {
                reg: /^verticalImage$/
            },
            {
                reg: /^auctionVideos$/
            },
            {
                reg: /^desc$/
            },
            {
                reg: /^wirelessDesc$/
            },
            // {
            //     reg: /^startTime$/
            // },
            {
                reg: /^shelfTime$/,
                props: {
                    style: {
                        width: '250px'
                    }
                }
            }
        ]
    },
    {
        title: '上架设置',
        fieldsMatch: [
            {
                reg: /^startTime$/
            },
        ]
    }
]